import { styles as gameItemStyles } from "components/Tools/GamesModal/GamesModal.styles"
import { maxWidth300, maxWidth600 } from "themes/default/breakpoints"

export const styles = {
  item: (theme) => ({
    maxWidth: 170,
    backgroundColor: theme.palette.background.card,
    // height: 240,
    // my: 1,
    m: 1,
    [maxWidth600]: {
      maxWidth: "100%",
      height: 175,
    },
    [maxWidth300]: {
      width: "100%",
      height: 215,
    },
  }),
  itemSimple: {
    height: "auto",
    backgroundColor: "transparent",
    boxShadow: "none",
    maxWidth: "100%",
    [maxWidth600]: {
      height: "auto",
    },
    [maxWidth300]: {
      height: "auto",
    },
  },
  itemContent: {
    textAlign: "center",
    justifyContent: "space-between",
    flex: 1,
    height: "100%",
    display: "flex",
    flexDirection: "column",
  },
  gameItem: gameItemStyles.gameItem,
  hoverButton: gameItemStyles.hoverButton,
  startButton: (theme) => ({
    width: "100%",
    textTransform: "none",
    backgroundColor: theme.palette.primary.light,
    mt: "25%",
    // text overflow
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    [maxWidth600]: {
      mt: 1,
    },
  }),
  itemContentSelected: (theme) => ({
    backgroundColor: theme.palette.primary.main,
  }),
}
